import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastContainer = () => {
  return (
    // Unfortunately react-hot-toast is not accessible by default
    // On page load we need to render a container with aria-live and role="status"
    // The screen reader will read out it's contents whenever new content is inserted
    <div aria-live="polite" role="status">
      <Toaster reverseOrder={false} />
    </div>
  );
};

export default ToastContainer;
